{
  "title": "Portfolio",
  "subtitle": "{projects} boards across {departments} of {total} teams",
  "subtitle_ws": "Oversight of {team}",
  "scope_note": "Board tasks only; personal tasks are not included.",
  "tabs": {
    "tasks": "Tasks",
    "health": "Board health"
  },
  "quick_filters": {
    "label": "Completed quick filters",
    "today": "Completed today",
    "this_week": "Completed this week",
    "this_month": "Completed this month"
  },
  "tiles": {
    "group_open": "About open work",
    "group_closed": "About closed work",
    "open": "Open",
    "overdue": "Overdue",
    "no_due_date": "No due date",
    "unassigned": "Unassigned",
    "no_evidence": "Closed without evidence",
    "quick_close": "Closed instantly",
    "of_open": "of {n} open",
    "open_now": "open right now",
    "not_applicable_closed_period": "Not applicable to a closing period"
  },
  "filters": {
    "department": "Team",
    "project": "Board",
    "assignee": "Person",
    "status": "Status",
    "period": "Period",
    "period_field": {
      "due": "Due",
      "completed": "Closed",
      "created": "Created"
    },
    "presets": {
      "today": "Today",
      "this_week": "This week",
      "this_month": "This month",
      "last_month": "Last month",
      "custom": "Custom"
    },
    "period_from": "From",
    "period_to": "To",
    "period_clear": "Clear period",
    "period_chip": "{field}: {range}",
    "period_scope": "Period: {label}",
    "period_all": "All",
    "search": "Search tasks…",
    "flags": "Signals",
    "group_by": "Group by",
    "sort": "Sort by",
    "clear": "Clear filters",
    "none_department": "No team",
    "none_assignee": "Unassigned",
    "all": "All",
    "n_selected": "{n} selected | {n} selected",
    "count": {
      "departments": "{n} team | {n} teams",
      "projects": "{n} board | {n} boards",
      "members": "{n} person | {n} people"
    },
    "direction_asc": "Ascending order",
    "direction_desc": "Descending order",
    "button": "Filters | Filters ({n}) | Filters ({n})",
    "sheet_title": "Filters",
    "apply": "Apply ({n} task) | Apply ({n} tasks)",
    "none_project": "No board"
  },
  "group_by": {
    "department": "Team",
    "project": "Board",
    "assignee": "Person"
  },
  "sort": {
    "due_date": "Due date",
    "created_at": "Created",
    "updated_at": "Last activity",
    "priority": "Priority"
  },
  "status": {
    "open": "Open",
    "in_progress": "In progress",
    "done": "Done",
    "cancelled": "Cancelled"
  },
  "flags": {
    "closed_only_hint": "Applies to completed tasks only; turning it on filters by Done.",
    "overdue": {
      "label": "Overdue",
      "hint": "Open task whose due date has passed."
    },
    "no_due_date": {
      "label": "No due date",
      "hint": "Open task without a due date."
    },
    "unassigned": {
      "label": "Unassigned",
      "hint": "Nobody is assigned to this task."
    },
    "no_description": {
      "label": "No description",
      "hint": "The task doesn't explain what needs to be done."
    },
    "stale": {
      "label": "Stale",
      "hint": "No changes in the last 14 days."
    },
    "quick_close": {
      "label": "Instant close",
      "hint": "Completed less than 2 minutes after creation: logged work, not a managed task."
    },
    "no_evidence": {
      "label": "No evidence",
      "hint": "Completed without any comment or attachment."
    }
  },
  "table": {
    "task": "Task",
    "project": "Board",
    "assignee": "Assignee",
    "due": "Due",
    "closed_at": "Closed",
    "status": "Status",
    "signals": "Signals",
    "no_due_date": "No date",
    "load_more": "Load more",
    "group_none_department": "No team",
    "group_none_assignee": "Unassigned",
    "count": "{n} task | {n} tasks",
    "group_count": "{loaded} of {total}",
    "showing": "Showing {shown} of {total}",
    "matching": "{n} task matches: | {n} tasks match:",
    "remove_filter": "Remove the {name} filter",
    "no_longer_matches": "No longer matches",
    "due_on": "Due {date}",
    "closed_on": "Closed {date}",
    "group_none_project": "No board (personal)",
    "no_project": "Personal (no board)"
  },
  "health": {
    "score": "Quality {score}/100",
    "score_none": "No data",
    "badge": {
      "green": "Healthy",
      "amber_quality": "Needs attention · quality {score}",
      "amber_overdue": "Needs attention · {overdue} of {open} overdue",
      "red_quality": "Critical · quality {score}",
      "red_overdue": "Critical · {overdue} of {open} overdue"
    },
    "sort": {
      "label": "Sort by",
      "worst": "Worst quality first",
      "most_overdue": "Most overdue",
      "name": "By team and board"
    },
    "attention": "{n} board needs attention | {n} boards need attention",
    "no_data_line": "{n} with no activity: {names}",
    "metrics": {
      "open": "Open",
      "overdue": "Overdue",
      "no_due_date_open": "No due date",
      "unassigned_open": "Unassigned",
      "done_30d": "Closed 30d",
      "quick_close_30d": "Instant 30d",
      "no_evidence_30d": "No evidence 30d"
    },
    "last_activity": "Last activity {when}",
    "no_activity": "No activity",
    "legend": "Quality combines how many open tasks have a due date and an assignee, and how many tasks closed in the last 30 days left evidence (a comment or attachment)."
  },
  "empty": {
    "no_tasks_title": "No tasks on any board yet",
    "no_tasks_body": "Tasks will show up here as teams create them on their boards.",
    "no_match_title": "No tasks match",
    "no_match_body": "Try different filters or clear them."
  },
  "forbidden": {
    "title": "Admins only",
    "body": "Only workspace admins can see the Portfolio."
  },
  "error": "Couldn't load the Portfolio.",
  "rate_limited": "Too many requests in a row. Retrying in {s} s…",
  "locked": {
    "title": "Oversee every team from one place",
    "body": "With the Business plan you see every task on every board, with quality signals and per-board health."
  },
  "report": {
    "button": "PDF report",
    "title": "Portfolio Report",
    "subtitle": "Built with the filters you have applied right now. If you change the filters, open this dialog again.",
    "scope_label": "Scope",
    "scope_all": "All dates",
    "tasks_count": "No tasks | {n} task | {n} tasks",
    "group_by": "Grouped by {group}",
    "ai_title": "Executive analysis (AI)",
    "ai_hint": "Optional: generate an AI analysis of the filtered set; it will be included in the PDF.",
    "generate_ai": "Generate analysis",
    "regenerate_ai": "Regenerate",
    "generating": "Analyzing the portfolio…",
    "download": "Download PDF",
    "downloading": "Generating PDF…",
    "error_ai": "The analysis could not be generated. Please try again.",
    "error_pdf": "The PDF could not be generated. Please try again.",
    "empty_hint": "No task matches the filters; the report will be empty."
  }
}
